<mat-form-field class="language-field" appearance="outline" [ngClass]="{'dark-mode': isDarkMode()}">

  <mat-select class="language-dropdown"  (selectionChange)="onSelectionChange($event)" [(value)]="language">

    <mat-option [value]="language.code" *ngFor="let language of supportedLanguages">
      <div class="dropdown-option-value">
        <img class="flag" [src]="getFlagUrl(language?.code)"> {{language.description}}
      </div>
    </mat-option>

    <mat-select-trigger>
      <div class="selected-language-value">
        <img class="flag" [src]="getFlagUrl(language)"> {{languageNamesMap[language]}}
      </div>
    </mat-select-trigger>

  </mat-select>

</mat-form-field>

